import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./UsTaxSettingForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelChangeUsTaxSetting} from "../../../actions/InventoryApiActions";
import {fromJS} from "immutable";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {GET_US_TAX_SETTING} from "../../../queries/sales";

const valid_options = fromJS([
  {id: "yes"},
  {id: "no"}
  ])

class ChangeUsTaxSettingFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    if (values.get("deductShippingCost") === "true") {
      return this.allow();
    } else {
      return this.disallow();
    }
  }

  allow() {
    return this.props.allowShippingCostDeductionForUsState({stateCode: this.props.stateCode})
      .then((response) => {
        if (response.data.allowShippingCostDeductionForUsState.errors.length <= 0) {
          this.props.cancelChangeUsTaxSetting();
        } else {
          let errors = createValidationErrors(response.data.allowShippingCostDeductionForUsState.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  disallow() {
    return this.props.disallowShippingCostDeductionForUsState({stateCode: this.props.stateCode})
      .then((response) => {
        if (response.data.disallowShippingCostDeductionForUsState.errors.length <= 0) {
          this.props.cancelChangeUsTaxSetting();
        } else {
          let errors = createValidationErrors(response.data.disallowShippingCostDeductionForUsState.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeUsTaxSetting();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS({
      deductShippingCost: data.usTaxSetting.deductShippingCost
    })
    return (
      <Form
        availabilities={valid_options}
        errors={this.state.errors}
        initialValues={initialValues}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ALLOW_SHIPPING_COST_DEDUCTION = gql`
  mutation allowShippingCostDeductionForUsState($data: StateCodeInput!) {
    allowShippingCostDeductionForUsState(input: $data) {
      errors { key message }
    }
  }
`;

const DISALLOW_SHIPPING_COST_DEDUCTION = gql`
  mutation disallowShippingCostDeductionForUsState($data: StateCodeInput!) {
    disallowShippingCostDeductionForUsState(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(GET_US_TAX_SETTING, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        stateCode: props.stateCode
      }
    })
  }),
  graphql(ALLOW_SHIPPING_COST_DEDUCTION, {
    props: ({ mutate }) => ({
      allowShippingCostDeductionForUsState: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(DISALLOW_SHIPPING_COST_DEDUCTION, {
    props: ({ mutate }) => ({
      disallowShippingCostDeductionForUsState: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ChangeUsTaxSettingFormContainerWithData = withQuery(ChangeUsTaxSettingFormContainer);

export default connect(null, {cancelChangeUsTaxSetting})(ChangeUsTaxSettingFormContainerWithData);